/**
 * The glTF loader with its extensions registered on demand.
 *
 * Importing the loader's `glTF/2.0` index registers every extension eagerly, and with them flow
 * graphs, audio emitters, splatting and more — half a megabyte of startup JavaScript the Quest
 * parses for nothing. The shipped models use three extensions (WebP textures, quantized meshes,
 * specular). Registering the built-in set as async factories keeps all of them working: each is
 * fetched the first time a file actually asks for it.
 */
import '@babylonjs/loaders/glTF/2.0/glTFLoader';
import { registerBuiltInGLTFExtensions } from '@babylonjs/loaders/glTF/2.0/Extensions/dynamic';

registerBuiltInGLTFExtensions();
